<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url"
                  :operate="operate"
                  :searchs="searchs"
                  :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "../../utils/message";

export default {
  name: "FixedIncome",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'name',
        placeholder: '项目名称',
        type: 'input',
      }, {
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '可购买'
        }, {
          key: 0,
          value: '已关闭'
        }]
      }, {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }],
      permission: {
        add: 'fixedIncome:add',
        update: 'fixedIncome:update',
        delete: 'fixedIncome:delete',
        deleteBatch: 'fixedIncome:deleteBatch'
      },
      url: {
        get: '/fixedIncome/listByCondition',
        add: '/fixedIncome/add',
        update: '/fixedIncome/update',
        delete: '/fixedIncome/delete/',
        delete_batch: '/fixedIncome/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'img',
        label: '图片',
        detail: true,
        show: true,
        img: true,
        width: '',
      }, {
        field: 'name',
        label: '项目名称',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'minAmount',
        label: '最小投资金额',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'maxAmount',
        label: '最大投资金额',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'cycle',
        label: '周期(天)',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'ratio',
        label: '日收益比例',
        show: {
          type: 'thousandthsRatio'
        },
        detail: true,
        width: '',
      }, {
        field: 'number',
        label: '购买次数',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'status',
        label: '状态',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '可购买',
            type: 'warning'
          }, {
            key: 0,
            value: '已关闭',
            type: 'danger'
          }]
        },
        //detail: true,
        width: '',
      }, {
        field: 'sort',
        label: '序号',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'calculate',
        label: '计算说明',
        show: false,
        detail: true,
        width: '',
      }, {
        field: 'description',
        label: '规则描述',
        show: false,
        detail: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        detail: true,
        width: '',
      }],
      operate: [{
        icon: 'el-icon-upload2',
        type: 'text',
        text: '上传图片',
        uploadImg: true,
        url: this.reUrl + '/system/upload/oss/img',
        // 用于存储handle的row
        value: {},
        handle: (row) => {
          this.value = row;
        },
        success: (res) => {
          if (res.code === 0) {
            const value = JSON.parse(JSON.stringify(this.value));
            value.img = res.data;
            this.$axios.post({
              url: '/fixedIncome/img/update',
              data: value,
              success: (data) => {
                if (data.code === 0) {
                  this.$message.success("图片上传成功");
                  this.$set(this.value, 'img', value.img);
                } else {
                  this.$message.error(data.msg ? data.msg : "图片上传失败");
                }
              }
            });
          } else if (res.code === 102) {
            window.localStorage.removeItem('username');
            window.localStorage.removeItem('sessionId');
            window.parent.location.href = this.feUrl + '/login.html';
          }
        }
      }, {
        icon: (row) => {
          return this.setValue(row, 'el-icon-unlock', 'el-icon-lock')
        },
        type: 'text',
        text: (row) => {
          return this.setValue(row, '开启购买', '关闭购买');
        },
        title: (row) => {
          return this.setValue(row, '确定开启该投资购买通道?', '确定关闭该投资购买通道?');
        },
        dynamic: true,
        handle: (row) => {
          const status = this.setValue(row, 1, 0);
          this.$axios.post({
            url: '/fixedIncome/status/update',
            data: {id: row.id, status: status},
            success: (data) => {
              if (data.code == 0) {
                message.success(this.setValue(row, '已开启该投资购买通道', '已关闭该投资购买通道'));
                row.status = status;
              } else {
                message.error(this.setValue(row, '开启该投资购买通道失败', '关闭该投资购买通道失败'));
              }
            }
          });
        },
      }],
      formFields: {
        addTitle: '添加固定收益',
        updateTitle: '修改固定收益',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'name',
          label: '项目名称',
          type: 'input',
          placeholder: '项目名称',
          rules: [{message: '请输入项目名称', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },
        //   {
        //   field: 'content',
        //   label: '内容',
        //   type: 'editor',
        //   placeholder: '内容',
        //   rules: [{message: '请输入内容', trigger: 'blur', required: true}],
        //   add: true,
        //   update: true,
        // },
          {
          field: 'minAmount',
          label: '最小金额',
          type: 'input',
          placeholder: '最小金额(USDT)',
          rules: [{
            message: '请输入最小金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'maxAmount',
          label: '最大金额',
          type: 'input',
          placeholder: '最大金额(USDT)',
          rules: [{
            message: '请输入最大金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'cycle',
          label: '周期',
          type: 'input',
          placeholder: '周期',
          rules: [{
            message: '请输入周期', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'ratio',
          label: '收益比例',
          type: 'money',
          placeholder: '收益比例(%)',
          rules: [{
            message: '请输入收益比例(%)', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'number',
          label: '购买次数',
          type: 'input',
          placeholder: '购买次数',
          rules: [{
            message: '请输入购买次数', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'status',
          label: '状态',
          type: 'select',
          selectData: [{
            id: 1,
            name: '开启购买通道',
          }, {
            id: 0,
            name: '关闭购买通道',
          }],
          placeholder: '请选择',
          rules: [{
            message: '请选择', trigger: 'blur', required: true
          }],
          add: true,
          update: false,
        }, {
          field: 'sort',
          label: '序号',
          type: 'input',
          placeholder: '序号',
          rules: [{
            message: '请输入序号', trigger: 'blur', required: false
          }],
          add: true,
          update: true,
        }, {
          field: 'calculate',
          label: '计算说明',
          type: 'input',
          placeholder: '计算说明',
          rules: [{
            message: '请输入计算说明', trigger: 'blur', required: false
          }],
          add: true,
          update: true,
        }, {
          field: 'description',
          label: '规则描述',
          type: 'textarea',
          placeholder: '规则描述',
          rules: [{
            message: '请输入规则描述', trigger: 'blur', required: false
          }],
          add: true,
          update: true,
        }],
      }
    }
  },
  methods: {
    setValue(row, v1, v2) {
      if (row.status === 0) {
        return v1;
      } else if (row.status === 1) {
        return v2
      }
    },
  }
}
</script>

<style scoped>

</style>
